(function () {
  if (customElements.get('ct-product-card')) return;

  function formatMoney(cents, format) {
    cents = Number(cents);
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (n % 100 === 0) precision = 0; /* $15.000 instead of $15.000,00 */
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    format = format || '${{amount}}';
    var match = format.match(placeholder);
    if (!match) return fmt(cents, 2);
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  class CtProductCard extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
      var qtyBtn = e.target.closest('.ct-qty__btn');
      if (qtyBtn && !qtyBtn.disabled) return this.setQty(qtyBtn);
      var atc = e.target.closest('[data-atc]');
      if (atc) return this.addToCart(atc);
    }

    setQty(btn) {
      this.querySelectorAll('.ct-qty__btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      var total = Number(this.dataset.price) * Number(btn.dataset.qty);
      this.querySelector('[data-total]').textContent = formatMoney(total, this.dataset.moneyFormat);
      this.querySelector('[data-error]').textContent = '';
    }

    async addToCart(btn) {
      var active = this.querySelector('.ct-qty__btn.is-active');
      var quantity = active ? Number(active.dataset.qty) : 1;
      var errorEl = this.querySelector('[data-error]');
      var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sections = cartEl && typeof cartEl.getSectionsToRender === 'function'
        ? cartEl.getSectionsToRender().map(function (s) { return s.section || s.id; })
        : ['cart-icon-bubble'];
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var label = btn.textContent;

      errorEl.textContent = '';
      btn.classList.add('is-loading');

      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: Number(this.dataset.variantId),
            quantity: quantity,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');

        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.classList.remove('is-empty');
          cartEl.renderContents(data);
        } else if (data.sections) {
          Object.keys(data.sections).forEach(function (id) {
            var target = document.getElementById(id);
            if (!target || !data.sections[id]) return;
            var doc = new DOMParser().parseFromString(data.sections[id], 'text/html');
            var src = doc.querySelector('.shopify-section') || doc.body;
            target.innerHTML = src.innerHTML;
          });
        }

        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ct-product-card', productVariantId: this.dataset.variantId, cartData: data });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

        btn.textContent = '¡Agregado!';
        setTimeout(function () { btn.textContent = label; }, 2000);
      } catch (err) {
        errorEl.textContent = err.message;
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }

  customElements.define('ct-product-card', CtProductCard);
})();
